export default {
  clientId: 'b407b001-8a30-4952-8802-cd4a83e91bc4',
  authority: 'https://login.microsoftonline.com/749d4192-cb4a-491e-80f8-d04f28350c89',
  redirectUri: process.env.VUE_APP_BASE_URL,
  postLogoutRedirectUri: process.env.VUE_APP_BASE_URL,
};
